var calendar = (function() {

  // Functions

  // Add day to any date
  function addDays(date, days) {
    var result = new Date(date);

    result.setDate(result.getDate() + days);
    return result;
  }
  // Format date
  function formatDate(date) {
    var monthNames = [
      "01", "02", "03",
      "04", "05", "06", "07",
      "08", "09", "10",
      "11", "12"
    ];

    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();

    return year + '-' + monthNames[monthIndex] + '-' + day;
  }

  // Vars
  var allEvents = [];
  var singleEvent = {};


  // Get all HTML data of each event and turn into object, then push into array "allEvents"
  $("#event-data-items .event-data").each(function() {
    singleEvent = {
      title : $(this).data("title"),
      description : $(this).data("description"),
      start : $(this).data("start"),
      end : $(this).data("end"),
      originalEndDate: $(this).data("endx"),
      location : $(this).data("location"),
      image : $(this).data("image"),
      url : $(this).data("url")
    };
    allEvents.push(singleEvent);
  });




  // Loop through allEvents and add 1 day to events with an end date
  var i;

  for (i = 0; i < allEvents.length; i++) {
    if(allEvents[i].start !== allEvents[i].end) {
      var endDate = new Date(allEvents[i].end);
      var startDate = new Date(allEvents[i].start);

      allEvents[i].end = formatDate(endDate);
      allEvents[i].start = formatDate(startDate);
    }
  }

  //console.log(allEvents);
  if($("#calendar").length > 0) {
    var locale = "en";

    if($("body").hasClass("FRCA")) {
      locale = "fr";
    }
    // Init calendar
    document.addEventListener('DOMContentLoaded', function() {
      var calendarEl = document.getElementById('calendar');

      var calendar = new FullCalendar.Calendar(calendarEl, {
        plugins: [ 'dayGrid' ],
        defaultView: 'dayGridMonth',
        header: {
          left: 'title',
          center: '',
          right: 'today timeGridWeek, timeGridDay prev,next'
        },
        height: 'auto',
        navLinks: true,
        scrollTime: '08:00:00',
        locale: locale,
        selectable: true,
        eventRender: function(info) {
          var unformattedDate = new Date(info.event._def.extendedProps.originalEndDate);
          var tooltip_title = info.event._def.title;
          var tooltip_content = info.event._def.extendedProps.description;
          var image_url = info.event._def.extendedProps.image;
          var location = info.event._def.extendedProps.location;
          var url = info.event._def.url;
          var start = formatDate(info.event.start);
          var end = "";

          if(info.event.end !== null) {
            end = " - " + formatDate(unformattedDate);
          }
          // Build tooltip content
          var tooltip_html = "";

          tooltip_html += "<div class='test-class'>";
          tooltip_html += "<h3>" + tooltip_title + "</h3>";
          tooltip_html += (image_url != "undefined" ? "<img src='" + image_url + "' alt='" + tooltip_title + "' class='img-fluid mb-2' />" : "");
          tooltip_html += "<div class='location'><small>" + location + " | <span class='text-blue'>" + start + "" + end + "</span></small></div>";
          tooltip_html += "<div class='summary'>" + tooltip_content + "</div>";
          tooltip_html += "<a class='btn blue mt-3' href='" + url + "' target='_blank'><span class='lang-en'>Lean more</span><span class='lang-fr'>En Savoir Plus</span></a>";
          tooltip_html += "</div>";
          var tooltip = new Tooltip(info.el, {
            title: tooltip_html,
            placement: 'top',
            trigger: 'hover',
            container: 'body',
            html: true
          });
        },
        eventClick: function(info) {
          info.jsEvent.preventDefault();

          if (info.event.url) {
            window.open(info.event.url);
          }
        },
        events: allEvents
      });

      calendar.render();
    });
  }
})();
